<template>
  <div>
    <div class="experiencias-container display-one">
      <div class="image-section">
        <img
          :src="require('../../../../assets/newlanding/Landing/banner-02.png')"
          alt="Equipo sonriente"
          class="team-image"
        />
      </div>
      <div class="content-section">
        <h1 class="title">Somos uno de los Mejores lugares para Trabajar en Perú</h1>

        <div class="stats-container">
          <div class="stat-item">
            <h2>5 años</h2>
            <p>en el ranking de Great Place to Work</p>
          </div>

          <div class="stat-item">
            <h2>+100</h2>
            <p>beneficios adicionales a los de ley, para ti y tu familia</p>
          </div>

          <div class="stat-item">
            <h2>20 000</h2>
            <p>Colaboradores/as con oportunidades de línea de carrera a través de nuestros programas de formación</p>
          </div>
        </div>

        <button class="cta-button" @click="redirect">Forma parte de nuestro equipo</button>
      </div>
    </div>
    <div class="experiencias-container display-two">
      <div class="image-section">
        <img
          :src="require('../../../../assets/newlanding/Landing/banner-02.png')"
          alt="Equipo sonriente"
          class="team-image"
        />
      </div>
      <div class="content-section">
        <h1 class="title">Somos uno de los Mejores lugares para Trabajar en Perú</h1>

        <div class="stats-container">
          <div class="stat-item">
            <h2>5 años</h2>
            <p>en el ranking de Great Place to Work</p>
          </div>

          <div class="stat-item">
            <h2>+100</h2>
            <p>beneficios adicionales a los de ley, para ti y tu familia</p>
          </div>

          <div class="stat-item">
            <h2>20 000</h2>
            <p>Colaboradores/as con oportunidades de línea de carrera a través de nuestros programas de formación</p>
          </div>
        </div>

        <button class="cta-button" @click="redirect">Forma parte de nuestro equipo</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExperienciasComponent",
  methods: {
    redirect() {
      this.$router.push("/empleos");
    },
  },
};
</script>

<style scoped>
.experiencias-container {
  display: flex;
  width: 100%;
  font-family: Arial, sans-serif;
  overflow: hidden;
}

.image-section {
  flex: 1;
  background-color: #f5f5f5;
  height: 500px;
}

.team-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.content-section {
  flex: 1;
  background-color: #3a0dc9;
  color: white;
  padding: 2rem;
  display: flex;
  flex-direction: column;
}

.title {
  font-size: 2.5rem !important;
  font-weight: bold;
  margin-bottom: 2rem;
  line-height: 1.2;
}

.highlight-text {
  position: relative;
}

.yellow-n {
  width: 45px;
}

.stats-container {
  display: flex;
  flex-direction: row;
  margin-bottom: 2rem;
  flex-wrap: nowrap;
  gap: 1rem;
  justify-content: space-between;
}

.stat-item {
  flex: 1;
  min-width: 0;
  border-right: 1px solid rgba(255, 255, 255, 0.2);
  padding-right: 0.5rem;
}

.stat-item:last-child {
  border-right: none;
}

.stat-item h2 {
  font-size: 1.5rem;
  margin-bottom: 0.3rem;
  font-weight: bold;
  white-space: nowrap;
}

.stat-item p {
  font-size: 0.8rem;
  margin: 0;
  line-height: 1.3;
}

.cta-button {
  background-color: #f0fa00;
  color: #0f0f72;
  border: none;
  padding: 0.8rem 1.5rem;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  align-self: flex-start;
  margin-top: auto;
  transition: background-color 0.3s ease;
}

.cta-button:hover {
  background-color: #e0ea00;
}
.display-two {
  display: none;
}

/* Mejoras para tabletas */
@media (max-width: 1024px) {
  .content-section {
    padding: 1rem;
  }

  .title {
    font-size: 2rem !important;
    margin-bottom: 1.5rem;
  }

  .stats-container {
    gap: 0.8rem;
  }

  .stat-item h2 {
    font-size: 1.3rem;
  }

  .stat-item p {
    font-size: 0.7rem;
  }
  .cta-button {
    align-self: center;
    padding: 0.5rem 0.7rem;
    font-size: 0.8rem;
    margin-top: 0rem;
    width: 80%;
    text-align: center;
  }
  .image-section {
    height: 350px;
  }
  .stats-container {
    margin-bottom: 1rem;
  }
}

/* Mejoras para dispositivos móviles */
@media (max-width: 768px) {
  .display-one {
    display: none;
  }
  .display-two {
    display: block;
  }
  .experiencias-container {
    flex-direction: column;
  }

  .image-section {
    /* height: 250px; */
  }
  .yellow-n {
    width: 35px;
  }

  .content-section {
    padding: 1.8rem;
  }

  .title {
    font-size: 2rem !important;
    margin-bottom: 0.8rem;
    text-align: center;
  }

  .stats-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.2rem;
    margin-bottom: 2rem;
  }

  .stat-item {
    border-right: none;
    padding-right: 0;
    text-align: center;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    padding-bottom: 1rem;
  }

  .stat-item:nth-child(3),
  .stat-item:nth-child(4) {
    border-bottom: none;
  }

  .stat-item h2 {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
  }

  .stat-item p {
    font-size: 0.8rem;
    line-height: 1.4;
  }

  .cta-button {
    align-self: center;
    padding: 1rem 1.5rem;
    font-size: 1.1rem;
    margin-top: 1rem;
    width: 80%;
    text-align: center;
  }
}

/* Mejoras específicas para móviles pequeños */
@media (max-width: 480px) {
  .image-section {
    /* height: 200px; */
  }

  .content-section {
    padding: 1.5rem;
  }

  .title {
    font-size: 1.5rem !important;
    margin-bottom: 0rem;
  }

  .yellow-n {
    width: 30px;
  }

  .stats-container {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .stat-item {
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    padding-bottom: 1rem;
    margin-bottom: 0;
  }

  .stat-item:last-child {
    border-bottom: none;
  }

  .stat-item h2 {
    font-size: 1.4rem;
  }

  .stat-item p {
    font-size: 0.8rem;
  }

  .cta-button {
    width: 100%;
    padding: 0.8rem 1rem;
  }
}
</style>
